
    var riot = require('riot')
    //src: starling/src/tags/node-perspectives-panel-item.html
riot.tag2('node-perspectives-panel-item',
  '<div class="node-perspective-item" onclick="{handleClick}" ondblclick="{ignoreDblClick}"> <div class="checkbox"> <input class="checkbox {this.isPartialMembership() ? \'partial\' : \'\'}" type="checkbox" checked="{this.parent.isChecked(this.perspective)}"> </div> <i class="material-icons perspective-point-icon" riot-style="color: {this.color};">visibility</i> <h4 ref="title" title="{this.getTitle().toString()}">{this.getTitle().toString()}</h4> <span hide="{this.isBulkAction()}" class="annotate {this._hasAnnotation() ? \'has-annotation\' : \'\'}" onclick="{annotate}" title="{this._hasAnnotation() ? \'View perspective note\' : \'Add perspective note\'}"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="17" viewbox="0 0 24 17"> <path fill-rule="evenodd" d="M5.82929429,7.5 L8,7.5 L8,2 C8,0.8954305 8.8954305,2.02906125e-16 10,0 L22,0 C23.1045695,-2.02906125e-16 24,0.8954305 24,2 L24,15 C24,16.1045695 23.1045695,17 22,17 L10,17 C8.8954305,17 8,16.1045695 8,15 L8,9.5 L5.82929429,9.5 C5.41745788,10.6651924 4.30621883,11.5 3,11.5 C1.34314575,11.5 0,10.1568542 0,8.5 C0,6.84314575 1.34314575,5.5 3,5.5 C4.30621883,5.5 5.41745788,6.33480763 5.82929429,7.5 Z M19.2578125,4.4921875 L12.7421875,4.4921875 L12.1796875,6.671875 L12.6484375,6.8125 C12.757813,6.57812383 12.8710932,6.36328223 12.9882812,6.16796875 C13.1054693,5.97265527 13.2304681,5.82421926 13.3632812,5.72265625 C13.4960944,5.62109324 13.6406242,5.55859387 13.796875,5.53515625 C13.9531258,5.51171863 14.1015618,5.5 14.2421875,5.5 L15.5078125,5.5 L15.5078125,10.75 C15.5078125,10.8750006 15.5000001,10.992187 15.484375,11.1015625 C15.4687499,11.210938 15.4179692,11.2968747 15.3320312,11.359375 C15.2460933,11.4218753 15.128907,11.4609374 14.9804688,11.4765625 C14.8320305,11.4921876 14.6718759,11.5 14.5,11.5 L14.5,11.9921875 L17.5,11.9921875 L17.5,11.5 C17.3281241,11.5 17.1679695,11.4921876 17.0195312,11.4765625 C16.871093,11.4609374 16.7539067,11.4218753 16.6679688,11.359375 C16.5820308,11.2968747 16.5312501,11.210938 16.515625,11.1015625 C16.4999999,10.992187 16.4921875,10.8750006 16.4921875,10.75 L16.4921875,5.5 L17.7578125,5.5 C17.8984382,5.5 18.0468742,5.51171863 18.203125,5.53515625 C18.3593758,5.55859387 18.5039056,5.62109324 18.6367188,5.72265625 C18.7695319,5.82421926 18.8945307,5.97265527 19.0117188,6.16796875 C19.1289068,6.36328223 19.242187,6.57812383 19.3515625,6.8125 L19.8203125,6.671875 L19.2578125,4.4921875 Z"></path> </svg> </span> </div>',
  '',
  'ref="main"', function(opts) {
'use strict';

var _this = this;

var _store_instance = require('../store_instance');

var _store_instance2 = _interopRequireDefault(_store_instance);

var _perspectivesUi = require('lib/perspectives-ui');

var _searchUi = require('lib/search-ui');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

this.perspective = _store_instance2.default.getPerspective(this.id);

this.on('mount', function () {
  $(_this.refs.main).on('mousedown touchstart pointerdown', function (e) {
    e.stopImmediatePropagation();
  });
});

this.isBulkAction = function () {
  return _this.parent.isBulkAction;
};

// underscore avoids conflict w/ perspective.hasAnnotation
this._hasAnnotation = function () {
  if (_this.parent.isBulkAction) {
    return false;
  }
  if (_this.parent.type != 'node') {
    return false;
  }
  return _this.perspective.hasAnnotation(_this.parent.tag.id);
};

this.membershipClass = function () {
  if (_this.parent.isBulkAction) {
    var bulkStatus = _this.parent.bulkMembershipStatus(_this.perspective);
    if (bulkStatus == 'all-members') {
      // all selected items are in P
      return 'fa-circle';
    } else if (bulkStatus == 'some-members') {
      // some items in P
      return 'fa-adjust';
    } else {
      // no items in P
      return 'fa-circle-o';
    }
  } else {
    if (_this.parent.isMember(_this.perspective)) {
      return 'fa-circle';
    } else {
      return 'fa-circle-o';
    }
  }
};

this.handleClick = function (e) {
  e.stopPropagation();
  if (_this.parent.isBulkAction) {
    _this.parent.handleBulkAction(_this.perspective);
  } else {
    _this.handleSingleAction();
  }
  _this.update();
};

this.annotate = function (e) {
  e.stopPropagation();
  _perspectivesUi.pui.addNodeToPerspective(_this.perspective, _this.parent.tag);
  _perspectivesUi.pui.showAnnotation(_this.id, _this.parent.tag.id);
};

this.handleSingleAction = function () {
  if (_this.parent.isMember(_this.perspective)) {
    if (_this.parent.type == 'node') {
      _perspectivesUi.pui.removeNodeFromPerspective(_this.perspective, _this.parent.tag);
    } else if (_this.parent.type == 'link') {
      _perspectivesUi.pui.removeLinkFromPerspective(_this.perspective, _this.parent.tag);
    }
  } else {
    if (_this.parent.type == 'node') {
      _perspectivesUi.pui.addNodeToPerspective(_this.perspective, _this.parent.tag);
    } else if (_this.parent.type == 'link') {
      _perspectivesUi.pui.addLinkToPerspective(_this.perspective, _this.parent.tag.instance);
      _this.parent.tag.update();
    }
  }
};

this.isPartialMembership = function () {
  if (!_this.parent.isBulkAction) {
    return false;
  }
  var bulkStatus = _this.parent.bulkMembershipStatus(_this.perspective);
  if (bulkStatus == 'some-members') {
    return true;
  }
  return false;
};

this.ignoreDblClick = function (e) {
  e.stopPropagation();
  e.preventDefault();
};

this.updateTitleHighlight = function () {
  if (!_this.refs || !_this.refs.title) {
    return;
  }
  // render in bold the part of  thetitle that matches new perspective input
  _this.refs.title.innerText = _this.getTitle().toString();
  // strip newlines (which are turning into br tags for some reason...)
  _this.refs.title.innerText = _this.refs.title.innerText.replace(/(\r\n|\n|\r)/gm, ' ');;
  if (_this.parent.newPerspectiveTitle && _this.parent.newPerspectiveTitle.length) {
    _this.parent.enboldenTitleSegment(_this.refs.title, _this.parent.newPerspectiveTitle);
  }
};

this.setFocusedStyle = function () {
  if (_this.refs.main) {
    _this.refs.main.classList.add('focused');
  }
};

this.unsetFocusedStyle = function () {
  if (_this.refs.main && _this.refs.main.classList.contains('focused')) {
    _this.refs.main.classList.remove('focused');
  }
};

this.on('updated', function () {
  _this.updateTitleHighlight();
});
this.on('mount', function () {
  _this.updateTitleHighlight();
});
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('node-perspectives-panel-item')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/node-perspectives-panel-item.html
// module id = 655
// module chunks = 0